import styled, { css } from "styled-components";
import { Flex, IconButton, IconButtonButton, MultiSelectContainer } from "@evergis/ui";

import { BAR_CHART_FOOTER_MARGIN } from "./constants";
import { MAX_CHART_WIDTH } from "../../constants";

export const StyledIconButton = styled(IconButton)`
  width: 0.75rem;
  height: 0.75rem;

  span[kind] {
    height: 0.75rem;

    :after {
      font-size: 0.75rem;
    }
  }
`;

export const TextFilterContainer = styled.div`
  width: 15.85rem;

  ${MultiSelectContainer} {
    color: ${({ theme: { palette } }) => palette.textPrimary};

    ${IconButtonButton} {
      span[kind]:after {
        color: ${({ theme: { palette } }) => palette.textPrimary};
      }
    }
  }
`;

export const BarChartContainer = styled.div<{ barHeight?: number; marginBottom?: number }>`
  width: 100%;
  overflow-x: hidden;

  ${({ barHeight, marginBottom }) =>
    !!barHeight &&
    css`
      .barChartBarGlobal rect {
        height: ${barHeight}px;
        y: calc(100% - ${barHeight + marginBottom}px);
      }
    `}
`;

export const AnyChartWrapper = styled.div<{ height?: number }>`
  width: 100%;
  height: ${({ height }) => height}px;
`;

export const BarChartWrapper = styled(AnyChartWrapper)`
  width: 100%;
  max-width: ${MAX_CHART_WIDTH}px;
  margin: 0 auto ${BAR_CHART_FOOTER_MARGIN}px;

  :hover {
    ${BarChartContainer} {
      overflow-x: auto;
    }
  }
`;

export const BarChartFilterHeader = styled(Flex)<{ height?: string | number }>`
  justify-content: space-between;
  align-items: center;
  height: ${({ height }) => `calc(${typeof height === "number" ? `${height}px` : height} - 0.5rem)`};
  padding: 0.25rem 0;
`;

export const BarChartFilterArrows = styled(Flex)`
  margin-left: -0.5rem;

  span[kind] {
    display: flex;
    align-items: center;

    :after {
      font-size: 0.75rem;
    }
  }
`;

export const BarChartFilterSelected = styled.div`
  font-size: 0.75rem;
  font-weight: bold;
  color: ${({ theme: { palette } }) => palette.textPrimary};
`;

export const NumberRangeSliderContainer = styled.div`
  color: ${({ theme: { palette } }) => palette.textSecondary};
`;
